/** Red blast-radius banner shown inside every destructive action card. */
import { Alert } from '@vnetwork/ui/feedback';

interface Props {
  warning: string;
}

export function EdgeActionWarning({ warning }: Props) {
  return (
    <Alert tone="danger" title="Destructive action — affects live traffic">
      {warning}
    </Alert>
  );
}
